import { isPlatformBrowser } from '@angular/common';
import { DestroyRef, Injectable, PLATFORM_ID, inject, signal } from '@angular/core';

export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

@Injectable({ providedIn: 'root' })
export class MobileService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  readonly isMobile = signal(false);

  constructor() {
    if (!isPlatformBrowser(this.platformId)) return;

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    this.isMobile.set(mediaQuery.matches);

    const updateMobileState = (event: MediaQueryListEvent): void => {
      this.isMobile.set(event.matches);
    };

    mediaQuery.addEventListener('change', updateMobileState);
    this.destroyRef.onDestroy(() => mediaQuery.removeEventListener('change', updateMobileState));
  }
}
